module.exports = __webpack_public_path__ + "assets/img/Logitech-Workspace.40d37bf4.webp";